<template>
    <div style="background: #f6f6f7 ;">
      <pcHeaders></pcHeaders>
      <div id="class1"></div>
      <pcBottom></pcBottom>
    </div>
  </template>
  <script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  // 例如：import 《组件名称》 from '《组件路径》';
  import pcHeaders from '../component/head.vue';
  import pcBottom from '../component/bottom.vue';
  import $ from 'jquery';
  import { toOrderConfirm, getOrderId } from '@/api/pay.js';
  
  export default {
    // import引入的组件需要注入到对象中才能使用
    components: {
      pcHeaders,
      pcBottom
    },
    data() {
      // 这里存放数据
      return {
        calssInfo: {}, //订单核对数据
        paymentNum: 0, //实付金额
        merchantNo: '', //商户号
        orderNo: '', //订单id
        zyName: '',
        derateType: ''
      };
    },
    mounted() {
    },
    created() {
    //   this.toOrderConfirm();
      getOrderId().then(res => {
        this.merchantNo = res.data.data.merchantNo;
        // this.orderNo = res.data.data.orderNo;
        this.userId=res.data.data.userId;
      });
      this.loadThirdPayScript();
    },
    computed: {},
    methods: {
      loadThirdPayScript() {
        const script = document.createElement('script');
        script.src = 'http://debug.epayservice.cn/thirdpay/resources/widget/js/thirdpay_widget.js';
        script.type = 'text/javascript';
        document.head.appendChild(script);
        let that = this;
        setTimeout(() => {
   
          $(document).ready(function () {
            console.log(that.merchantNo, that.orderNo, that.paymentNum,that.userId, '99');
            thirdpay_widget.init({
              container:'class1',
              merchant_no: that.merchantNo, //商户号
              merchant_order_no: that.$route.query.orderNo, //商户订单号
              amount: that.$route.query.paymentNum * 100, //订单金额
              charge_param: {
                classIds: '', //  班级ID数组，
                courseId: '', //资源库单独购买课程的id
                derateType: '02', //  减免方式
                orderNo: that.$route.query.orderNo,//  订单编号
                userId:that.userId,
                oldFlag :'02'
              },
              widgetParam: {
                businessNo:that.$route.query.orderNo,
                regCode: '150295',
                businessType: '001',
                agencyCode: '214001',
                date: '2023-12-04',
                payerName: '测试人员',
                payerTel: '13913110970',
                payeeAccAssignType: '1',
                totalAmt: that.$route.query.paymentNum * 100,
                author: '测试1',
                placeCode: '001',
                billCode: '0004',
                itemDetails: [
                  {
                    itemCode: '103042789',
                    itemName: '成人教育学费',
                    unit: '人/次',
                    number: 1,
                    std: that.$route.query.paymentNum * 100,
                    amt: that.$route.query.paymentNum * 100
                  }
                ]
              },
  
              subject: '向呼和浩特人事考试中心缴费"', // 商品标题
              body: '向呼和浩特人事考试中心缴培训费', // 商品描述信息
              charge_url: 'http://192.168.1.103:9092/order/toGenerateOrderNew.html', //后端 URL
              device_type: 'pc', //设备类型
              version_no: '1.1' //版本编码
            });
          }); 
  
        }, 
        1000);
  
      },
    //   toOrderConfirm() {
    //     toOrderConfirm({ classIds:this.$route.query.classIds }).then(res => {
    //       console.log(res.data);
    //       if (res.data.data.code == '1') {
    //         this.calssInfo = res.data.data.data;
    //         this.deductionNum = this.calssInfo.balance;
    //         this.paymentNum = this.calssInfo.totalPrice;
    //         console.log(this.paymentNum,'kkk');
            
    //         if (this.deductionNum !== 0 && this.paymentNum !== null) {
    //           this.showSelet = true;
    //         } else {
    //           this.showSelet = false;
    //         }
    //       } else {
    //         this.$message(res.data.data.msg);
    //         this.$router.back();
    //       }
    //     });
    //   }
    }
  };
  </script>
  <style lang="less" scoped>
  /* //@import url(); 引入公共css类 */
  #class1{
      height: 550px;
  
  }
  * {
    font-family: Regular;
  }
  ::v-deep{
  #widget_thirdapy_bosssoft .tabbox_bank{
    width: 71%;
  }
  #widget_thirdapy_bosssoft .order {
    width: 71%;
    padding: 20px 40px;
  }
}
  </style>
  